import { Trans } from 'react-i18next';

import { Alert } from 'components/Blocks';
import { isValidJustification } from './utils';

interface RequiredJustificationAlertProps {
  text: string;
}

/**
 * Useful when you want the user to provide a justification/comment for an action
 * and explicitly want to show an indication that it should be properly filled.
 *
 * Combine with the `isValidJustification` exported from this to validate outside
 */
export function RequiredJustificationAlert({ text }: RequiredJustificationAlertProps) {
  const showWarning = !isValidJustification(text) && text.length >= 3;

  if (showWarning)
    return (
      <Alert level="warning">
        <Trans i18nKey="justification-warning" />
      </Alert>
    );

  return (
    <Alert>
      <Trans i18nKey="justification-info" />
    </Alert>
  );
}
